import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axiosAdmin from "../../../../api/apiAdmin";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import { TextInput } from "../../inputComponents/inputcomp";
import logo from "../../../img/phoneLogo.png";

const PopupsUpdate = () => {
  const { t } = useTranslation();
  const { popupId } = useParams();
  const [popupData, setPopupData] = useState({});

  const handleNewPopup = (value, inputName) => {
    setPopupData((prev) => ({ ...prev, [inputName]: value }));
  };

  const handleEdit = () => {
    axiosAdmin
      .put(`/popup/${popupId}`, popupData)
      .then(({ data }) => {
        successToast(t("admin_data_updated_success"));
      })
      .catch((err) => {
        errorToast(t("admin_error_try_again"));
      });
  };

  useEffect(() => {
    axiosAdmin
      .get(`/popup/${popupId}`)
      .then(({ data }) => {
        setPopupData(data);
      })
      .catch((err) => {});
  }, []);

  return (
    <div
      className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 
            min-h-screen p-10 sm:p-5 pb-24 sm:pb-24"
    >
      <div className="sm:px-0">
        <div className="w-full rounded-xl bg-white dark:bg-slate-700 p-5">
          <div className="flex items-center justify-between flex-wrap gap-5">
            <div className="w-[100px] h-10">
              <img src={logo} className="w-full h-full" />
            </div>
            <button
              onClick={handleEdit}
              className="rounded-lg p-3 text-white text-sm bg-violet-400 sm:w-full"
            >
              {t("admin_save")}
            </button>
          </div>
          <div className="pt-5 grid grid-cols-1 gap-5">
            <TextInput
              name={t("admin_text_georgian")}
              inputName={"ge"}
              inputSetter={handleNewPopup}
              value={popupData.ge}
            />
            <TextInput
              name={t("admin_text_english")}
              inputName={"en"}
              inputSetter={handleNewPopup}
              value={popupData.en}
            />
            <TextInput
              name={t("admin_text_russian")}
              inputName={"ru"}
              inputSetter={handleNewPopup}
              value={popupData.ru}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupsUpdate;
